import { ComponentProps } from "react";
import { RouteFactory } from "@app/routePaths";
import { NEWSLETTER_TYPE } from "@components/Newsletter/types/Newsletter";
import Card from "@particles/card/Card";
import { SanitizedFeedSectionArticle } from "@typings/Cue";

/**
 * Get the keyword path for the newsletter archive page based on the relative path.
 */
export const getNewsletterArchiveKeywordPath = (
  relativePath: string
): string | undefined => {
  switch (relativePath) {
    case RouteFactory.newsletterGarageArchivePage:
      return "/keywords/garage-newsletter";
  }
};

/**
 * Get newsletter archive title based on the relative path.
 */
export const getNewsletterArchiveTitle = (relativePath: string): string => {
  switch (relativePath) {
    case RouteFactory.newsletterGarageArchivePage:
      return "Garage";

    default:
      return "Newsletter Archive";
  }
};

/**
 * Get the newsletter to skip based on the relative path.
 */
export const getNewsletterTypeBasedOnRelativePath = (
  relativePath: string
): NEWSLETTER_TYPE => {
  switch (relativePath) {
    case RouteFactory.newsletterGarageArchivePage:
      return NEWSLETTER_TYPE.GARAGE;

    default:
      return NEWSLETTER_TYPE.MORNING;
  }
};

/**
 * Get newsletter archive article cards props
 */
export const getNewsletterArchiveArticleCardsProps = (
  articles: SanitizedFeedSectionArticle[]
): ComponentProps<typeof Card>[] => {
  return articles.map(({ id, title, urlPath, updated, paywall }) => {
    return {
      id,
      title,
      link: urlPath,
      updatedTime: updated,
      displayPaywall: paywall?.contentAccess === "1",
    };
  });
};
